<template>
    <div>
    <div v-for="(filter, i) in offerGroups" :key="`filter-group-${i}`" class="filter__item brands">
        <span class="filter__title" data-for="marcas">{{ filter.title }}</span>
        <div class="filter__content" data-name="marcas" data-type="checkboxes">
            <div class="filter--checkbox">
                <input type="checkbox" name="motorola" id="motorola"/>
                <label for="motorola" class="">item</label>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name: 'offers-filter',
    data: () => {
        return {
            offerGroups: [
                {
                    title: 'Marcas',
                    items: [
                        'Motorola',
                        'Samsung',
                        'Huawei'
                    ]
                },
                {
                    title: 'Sistema Operativo',
                    items: [
                        'Android',
                        'IOS',
                        'Windows'
                    ]
                },
                {
                    title: 'Tipo de Dispositivo',
                    items: [
                        'Celular',
                        'TV',
                        'Tablet',
                        'Audífonos',
                        'Laptop',
                        'Desktop'
                    ]
                }
            ]
        }
    }
}
</script>

<style lang="css">
.filter__item {
    margin:15px 0;
}
</style>


// WEBPACK FOOTER //
// offers-filter.vue?2f8501ac